import React from 'react'
import PropTypes from 'prop-types'

import { settings } from 'parking-react-common'

import Map from '../components/Map'

import MapPolygonsList from '../components/MapPolygonsList'
import ErrorMessage from '../components/ErrorMessage'

const MapPolygonsField = (props) => {
    const {
        label, input, meta, center, bounds, zoom, color
    } = props
    const { name, onChange, value } = input
    const { error } = meta

    return (
        <div>
            { label && <label htmlFor={ name }>{ label }</label> }
            <Map
                center={ center }
                zoom={ zoom }
                bounds={ bounds }
            >
                <MapPolygonsList
                    data={ value }
                    onChange={ onChange }
                    isEditable
                    color={ color }
                />
            </Map>
            { error && <ErrorMessage error={ error } /> }
        </div>
    )
}

MapPolygonsField.propTypes = {
    label  : PropTypes.string,
    input  : PropTypes.object,
    meta   : PropTypes.object,
    color  : PropTypes.string,
    center : PropTypes.object,
    bounds : PropTypes.arrayOf(PropTypes.array),
    zoom   : PropTypes.number
}

MapPolygonsField.defaultProps = {
    center : settings.DEFAULT_STARTING_COORDINATES,
    zoom   : 14
}

export default MapPolygonsField
